export const TUTOR_DESK_SAAS_FINAL_UI_SETTINGS_STYLES = `
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] {
  --kg-settings-final-wordmark-main-artwork-width: 140%;
  --kg-settings-final-wordmark-main-offset-y: 3px;
  --kg-settings-final-wordmark-preview-artwork-width: 116%;
  --kg-settings-final-wordmark-slot-height: calc(var(--ttoria-final-control-height) + var(--ttoria-final-shell-grid-gap));
  --kg-settings-final-preview-wordmark-slot-height: calc(var(--ttoria-final-control-gap) * 4);
  width: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: var(--ttoria-final-canvas);
  box-shadow: none;
  color: var(--ttoria-final-text);
  font-family: var(--ttoria-final-font-body);
}

/*
 * Settings is the one supplied v1 page whose reference intentionally keeps
 * the shared shell status surface visible while it is idle. Restore that
 * canonical surface only while the qualified Settings renderer owns the
 * active shell host. Cached/inactive Settings markup must not uncollapse the
 * status surface on AI Quality or any other route.
 */
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"][data-kg-ui-surfaces~="settings"]:not([data-kg-async-feedback-standard="ttoria-saas-async-feedback-v1"]):has(
  .platform-shell-plugin-host:not(.is-inactive):not([aria-hidden="true"])
  .kg-settings-root[data-kg-saas-final-ui-settings="true"]
) .ds-shell-layout.platform-shell-layout > .ds-shell-layout__main > .ds-shell-layout__status:has(
  .tutor-desk-global-status[data-visual-idle="true"][data-has-center-controls="false"][data-has-panel-controls="false"]
) {
  position: relative;
  width: 100%;
  height: auto;
  min-width: 0;
  min-height: 0;
  max-width: none;
  max-height: none;
  margin: 0;
  padding: 0;
  overflow: visible;
  border: 0;
  clip: auto;
  clip-path: none;
  white-space: normal;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"][data-kg-ui-surfaces~="settings"]:not([data-kg-async-feedback-standard="ttoria-saas-async-feedback-v1"]):has(
  .platform-shell-plugin-host:not(.is-inactive):not([aria-hidden="true"])
  .kg-settings-root[data-kg-saas-final-ui-settings="true"]
) .ds-shell-status.platform-shell-layout__status-shell:has(
  .tutor-desk-global-status[data-visual-idle="true"][data-has-center-controls="false"][data-has-panel-controls="false"]
) {
  position: relative;
  z-index: 600;
  isolation: isolate;
  width: 100%;
  height: auto;
  min-width: 0;
  min-height: var(--ttoria-final-top-bar-height);
  max-width: none;
  max-height: none;
  margin: 0;
  padding: var(--ttoria-final-top-bar-padding-block) var(--ttoria-final-shell-outer-padding);
  overflow: visible;
  border: 1px solid var(--ttoria-final-border);
  border-radius: var(--ttoria-final-radius-card);
  background: var(--ttoria-final-surface);
  background-image: none;
  box-shadow: none;
  color: var(--ttoria-final-text);
  clip: auto;
  clip-path: none;
  white-space: normal;
}

@media (min-width: 1024px) {
  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"][data-kg-ui-surfaces~="settings"]:not([data-kg-async-feedback-standard="ttoria-saas-async-feedback-v1"]):has(
    .platform-shell-plugin-host:not(.is-inactive):not([aria-hidden="true"])
    .kg-settings-root[data-kg-saas-final-ui-settings="true"]
  ) .ds-shell-status.platform-shell-layout__status-shell:has(
    .tutor-desk-global-status[data-visual-idle="true"][data-has-center-controls="false"][data-has-panel-controls="false"]
  ) {
    border: 0;
    border-bottom: 1px solid var(--ttoria-final-border);
    border-radius: 0;
  }
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] > .ds-panel__title {
  display: none;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] > .ds-panel__body {
  width: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--ttoria-final-shell-grid-gap);
  padding: var(--ttoria-final-card-padding);
  overflow: auto;
  background: var(--ttoria-final-canvas);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .ds-plugin-page-panel__header {
  display: grid;
  gap: 4px;
  padding: 0 6px;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .ds-plugin-page-panel__title {
  margin: 0;
  color: var(--ttoria-final-text);
  font-family: var(--ttoria-final-font-heading);
  font-size: var(--ttoria-final-page-title-size);
  font-weight: 700;
  line-height: var(--ttoria-final-page-title-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .ds-plugin-page-panel__subtitle {
  margin: 0;
  color: var(--ttoria-final-text-muted);
  font-family: var(--ttoria-final-font-body);
  font-size: var(--ttoria-final-body-size);
  font-weight: 400;
  line-height: var(--ttoria-final-body-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .ds-plugin-page-panel__status-strip:empty {
  display: none;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .ds-plugin-page-panel__content-region,
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-shell-body {
  width: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--ttoria-final-shell-grid-gap);
  overflow: visible;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-app-identity {
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--ttoria-final-control-gap);
  padding: var(--ttoria-final-card-padding);
  border: 1px solid var(--ttoria-final-border);
  border-radius: var(--ttoria-final-radius-card);
  background: var(--ttoria-final-surface);
  color: var(--ttoria-final-text);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-app-identity__logo {
  position: relative;
  width: var(--ttoria-final-trigger-width);
  height: var(--kg-settings-final-wordmark-slot-height);
  display: block;
  flex: 0 1 var(--ttoria-final-trigger-width);
  max-width: 100%;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: transparent;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-app-identity__logo img {
  position: absolute;
  top: calc(50% + var(--kg-settings-final-wordmark-main-offset-y));
  left: 50%;
  width: var(--kg-settings-final-wordmark-main-artwork-width);
  height: auto;
  max-width: none;
  transform: translate(-50%, -50%);
  filter: var(--ttoria-final-wordmark-filter-current);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"][data-kg-tutor-desk-theme-mode="dark"] .kg-settings-final-app-identity__logo img {
  filter: var(--ttoria-final-wordmark-filter-dark);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"][data-kg-tutor-desk-theme-mode="default"] .kg-settings-final-app-identity__logo img {
  filter: var(--ttoria-final-wordmark-filter-light);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-app-identity__copy {
  min-width: 0;
  display: grid;
  flex: 1 1 var(--ttoria-final-secondary-action-width);
  gap: 2px;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-app-identity__copy strong {
  color: var(--ttoria-final-text);
  font-size: var(--ttoria-final-body-size);
  line-height: var(--ttoria-final-body-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-app-identity__copy span {
  color: var(--ttoria-final-text-muted);
  font-size: var(--ttoria-final-label-size);
  line-height: var(--ttoria-final-label-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-nav {
  width: 100%;
  min-width: 0;
  min-height: var(--ttoria-final-control-height);
  display: flex;
  align-items: flex-end;
  gap: 0;
  margin: 0;
  padding: 0 16px;
  overflow-x: auto;
  border: 1px solid var(--ttoria-final-border);
  border-radius: var(--ttoria-final-radius-card) var(--ttoria-final-radius-card) 0 0;
  background: var(--ttoria-final-surface);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-main-tabs,
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .ds-tabs__list {
  width: 100%;
  min-width: max-content;
  display: flex;
  gap: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .ds-tabs__tab {
  min-height: var(--ttoria-final-control-height);
  padding: 0 16px;
  border: 0;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  color: var(--ttoria-final-text-muted);
  font-size: var(--ttoria-final-body-size);
  font-weight: 700;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .ds-tabs__tab[aria-selected="true"],
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .ds-tabs__tab.active {
  border-bottom-color: var(--ttoria-final-action);
  color: var(--ttoria-final-action);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-panels,
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-panel,
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-panel-body {
  width: 100%;
  min-width: 0;
  min-height: 0;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-panel-body {
  padding: 0;
  overflow: visible;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"][data-kg-ui-surfaces~="settings"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 [data-ds-component="ds/button"] {
  min-height: var(--ttoria-final-control-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox[data-ds-component="ds/checkbox"] {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  min-height: 44px;
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  padding: 8px 0;
  color: var(--ttoria-final-text);
  cursor: pointer;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox__control {
  position: relative;
  width: 20px;
  min-width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  margin-top: 1px;
  overflow: hidden;
  border: 1px solid var(--ttoria-final-border-strong);
  border-radius: 5px;
  background: var(--ttoria-final-canvas);
  color: var(--ttoria-final-action-contrast);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox__native {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox__mark {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  pointer-events: none;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox:has(.ds-checkbox__native:checked) .ds-checkbox__control {
  border-color: var(--ttoria-final-action);
  background: var(--ttoria-final-action);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox:focus-within .ds-checkbox__control {
  outline: 2px solid var(--ttoria-final-action);
  outline-offset: 2px;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox__content {
  min-width: 0;
  display: grid;
  gap: 4px;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 :where(.ds-checkbox__label, .ds-checkbox__helper) {
  display: block;
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox__label {
  color: var(--ttoria-final-text);
  font-family: var(--ttoria-final-font-body);
  font-size: var(--ttoria-final-body-size);
  font-weight: 700;
  line-height: var(--ttoria-final-body-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox__helper {
  color: var(--ttoria-final-text-muted);
  font-family: var(--ttoria-final-font-body);
  font-size: var(--ttoria-final-label-size);
  font-weight: 400;
  line-height: var(--ttoria-final-label-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .tutor-desk-settings-v2 .ds-checkbox[aria-disabled="true"] {
  opacity: 0.72;
  cursor: not-allowed;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] #inviteForm .kg-settings-users-form-grid {
  grid-template-columns: minmax(0, 1fr) minmax(0, var(--ttoria-final-main-action-width));
  gap: var(--ttoria-final-control-gap);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] #inviteForm .kg-settings-users-action,
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] #inviteBtn {
  width: var(--ttoria-final-main-action-width);
  max-width: 100%;
  justify-self: end;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"][data-active-panel="appearance"] .kg-settings-panels,
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"][data-active-panel="appearance"] .kg-settings-panel[data-panel="appearance"],
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"][data-active-panel="appearance"] .kg-settings-panel[data-panel="appearance"] > .kg-settings-panel-body {
  min-height: auto;
  flex: 0 0 auto;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-panel {
  width: 100%;
  min-width: 0;
  min-height: auto;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--ttoria-final-border);
  border-radius: var(--ttoria-final-radius-card);
  background: var(--ttoria-final-surface);
  box-shadow: none;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-panel > .ds-sub-panel__header {
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  margin: 0;
  padding: var(--ttoria-final-card-padding) var(--ttoria-final-card-padding) 0;
  border: 0;
  background: transparent;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-panel > .ds-sub-panel__header > .ds-sub-panel__label {
  margin: 0;
  color: var(--ttoria-final-text);
  font-family: var(--ttoria-final-font-heading);
  font-size: var(--ttoria-final-section-title-size);
  font-weight: 700;
  line-height: var(--ttoria-final-section-title-line-height);
  text-transform: none;
  letter-spacing: normal;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-panel > .ds-sub-panel__body {
  width: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--ttoria-final-shell-grid-gap);
  padding: 10px var(--ttoria-final-card-padding) 0;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-intro {
  margin: 0;
  color: var(--ttoria-final-text-muted);
  font-size: var(--ttoria-final-body-size);
  line-height: var(--ttoria-final-body-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-pack-grid--appearance {
  width: 100%;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: var(--ttoria-final-shell-grid-gap);
  margin: 0;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-card {
  min-width: 0;
  min-height: var(--ttoria-final-settings-theme-card-min-height);
  display: flex;
  flex-direction: column;
  gap: var(--ttoria-final-control-gap);
  padding: var(--ttoria-final-control-gap);
  border: 1px solid var(--ttoria-final-border);
  border-radius: var(--ttoria-final-radius-card);
  background: var(--ttoria-final-surface);
  box-shadow: none;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-card.active {
  border-color: var(--ttoria-final-action);
  box-shadow: var(--ttoria-final-focus-ring);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview {
  --kg-settings-final-preview-canvas: var(--ttoria-final-preview-dark-canvas);
  --kg-settings-final-preview-surface: var(--ttoria-final-preview-dark-surface);
  --kg-settings-final-preview-border: var(--ttoria-final-preview-dark-border);
  width: 100%;
  min-height: var(--ttoria-final-settings-theme-preview-height);
  display: grid;
  grid-template-columns: 24% minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid var(--kg-settings-final-preview-border);
  border-radius: var(--ttoria-final-radius-control);
  background: var(--kg-settings-final-preview-canvas);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview[data-theme-mode="default"] {
  --kg-settings-final-preview-canvas: var(--ttoria-final-preview-light-canvas);
  --kg-settings-final-preview-surface: var(--ttoria-final-preview-light-surface);
  --kg-settings-final-preview-border: var(--ttoria-final-preview-light-border);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__rail {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 8px;
  border-right: 1px solid var(--kg-settings-final-preview-border);
  background: var(--kg-settings-final-preview-surface);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__wordmark {
  position: relative;
  width: 100%;
  min-height: var(--kg-settings-final-preview-wordmark-slot-height);
  display: block;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: transparent;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__wordmark img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: var(--kg-settings-final-wordmark-preview-artwork-width);
  height: auto;
  max-width: none;
  transform: translate(-50%, -50%);
  filter: var(--ttoria-final-wordmark-filter-dark);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview[data-theme-mode="default"] .kg-settings-final-theme-preview__wordmark img {
  filter: var(--ttoria-final-wordmark-filter-light);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__rail-line,
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__bar,
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__card {
  display: block;
  border: 1px solid var(--kg-settings-final-preview-border);
  border-radius: 4px;
  background: var(--kg-settings-final-preview-surface);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__rail-line {
  min-height: 12px;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__rail-line--active {
  border-color: var(--ttoria-final-action);
  background: color-mix(in srgb, var(--ttoria-final-action) 38%, var(--kg-settings-final-preview-surface));
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__canvas {
  display: grid;
  grid-template-rows: 22px minmax(0, 1fr);
  gap: 10px;
  padding: 10px;
  background: var(--kg-settings-final-preview-canvas);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-preview__cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-card__heading {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ttoria-final-control-gap);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-card__heading strong {
  color: var(--ttoria-final-text);
  font-family: var(--ttoria-final-font-heading);
  font-size: var(--ttoria-final-section-title-size);
  line-height: var(--ttoria-final-section-title-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-badge {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border: 1px solid color-mix(in srgb, var(--ttoria-final-action) 50%, var(--ttoria-final-border));
  border-radius: var(--ttoria-final-radius-selected);
  background: color-mix(in srgb, var(--ttoria-final-action) 18%, var(--ttoria-final-surface));
  color: var(--ttoria-final-action);
  font-size: var(--ttoria-final-label-size);
  font-weight: 700;
  line-height: var(--ttoria-final-label-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-theme-card > [data-ds-component="ds/button"] {
  width: var(--ttoria-final-secondary-action-width);
  max-width: 100%;
  align-self: flex-end;
  margin-top: auto;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-inline-controls {
  width: calc(100% + (2 * var(--ttoria-final-card-padding)));
  display: flex;
  justify-content: flex-end;
  margin: 8px calc(-1 * var(--ttoria-final-card-padding)) 0;
  padding: 16px var(--ttoria-final-card-padding);
  border-top: 1px solid var(--ttoria-final-border);
  background: var(--ttoria-final-surface);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--ttoria-final-control-gap);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-actions [data-ds-component="ds/button"] {
  min-height: var(--ttoria-final-control-height);
  height: var(--ttoria-final-control-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-actions [data-action="appearance-apply"] {
  width: var(--ttoria-final-main-action-width);
  border-color: var(--ttoria-final-action);
  background: var(--ttoria-final-action);
  color: var(--ttoria-final-action-contrast);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-actions [data-action="appearance-preview"],
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-actions [data-action="appearance-reset"] {
  width: var(--ttoria-final-secondary-action-width);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-table__grid {
  width: 100%;
  min-width: var(--ttoria-final-table-min-width);
  display: grid;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-table__row {
  display: contents;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-table__cell--align-end {
  text-align: right;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-delete-confirm-field {
  margin-top: var(--ttoria-final-control-gap);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-final-date-icon {
  width: var(--ttoria-final-icon-size);
  height: var(--ttoria-final-icon-size);
  display: block;
  background-color: currentColor;
  mask-image: var(--td-icon-calendar);
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: grid;
  place-items: center;
  padding: 24px;
  overflow: auto;
  background: var(--ttoria-final-overlay);
  backdrop-filter: blur(7px);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-backdrop.hidden {
  display: none;
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host {
  width: min(760px, calc(100vw - 48px));
  min-width: 0;
  max-width: 100%;
  max-height: min(88dvh, 920px);
  display: flex;
  color: var(--ttoria-final-text);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host > .ds-modal {
  --ds-adaptive-modal-padding: 0px;
  --ds-adaptive-modal-gap: 0px;
  width: 100%;
  min-width: 0;
  max-width: none;
  max-height: inherit;
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 1px solid var(--ttoria-final-action);
  border-radius: var(--ttoria-final-radius-card);
  background: var(--ttoria-final-surface);
  box-shadow: var(--ttoria-final-shadow);
  color: var(--ttoria-final-text);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host > .ds-modal .ds-modal__body {
  min-width: 0;
  padding: var(--ttoria-final-card-padding) 24px;
  overflow: auto;
  background: var(--ttoria-final-surface);
  color: var(--ttoria-final-text);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host > .ds-modal .ds-modal__footer {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--ttoria-final-control-gap);
  padding: 16px 24px var(--ttoria-final-card-padding);
  border-top: 1px solid var(--ttoria-final-border);
  background: var(--ttoria-final-surface);
  color: var(--ttoria-final-text);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host :where(.modal-message, .kg-settings-structured-note, .kg-settings-structured-empty, .kg-settings-structured-summary) {
  color: var(--ttoria-final-text-muted);
  font-family: var(--ttoria-final-font-body);
  font-size: var(--ttoria-final-body-size);
  font-weight: 400;
  line-height: var(--ttoria-final-body-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host :where(.kg-settings-structured-value, .kg-settings-structured-table td, .kg-settings-structured-pill) {
  color: var(--ttoria-final-text);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host :where(.kg-settings-structured-scroll, .kg-settings-structured-details, .kg-settings-structured-table-wrap, .kg-settings-structured-block, .kg-settings-modal-access-group) {
  border-color: var(--ttoria-final-border);
  border-radius: var(--ttoria-final-radius-control);
  background: var(--ttoria-final-canvas);
  color: var(--ttoria-final-text);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host :where(input:not([type="checkbox"]):not([type="radio"]), select, textarea, .ds-input__control, .ds-input__value) {
  border-color: var(--ttoria-final-border);
  border-radius: var(--ttoria-final-radius-control);
  background: var(--ttoria-final-canvas);
  box-shadow: none;
  color: var(--ttoria-final-text);
  font-family: var(--ttoria-final-font-body);
  font-size: var(--ttoria-final-body-size);
  line-height: var(--ttoria-final-body-line-height);
}

html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-1 .kg-settings-table__grid { grid-template-columns: repeat(1, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-2 .kg-settings-table__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-3 .kg-settings-table__grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-4 .kg-settings-table__grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-5 .kg-settings-table__grid { grid-template-columns: repeat(5, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-6 .kg-settings-table__grid { grid-template-columns: repeat(6, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-7 .kg-settings-table__grid { grid-template-columns: repeat(7, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-8 .kg-settings-table__grid { grid-template-columns: repeat(8, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-9 .kg-settings-table__grid { grid-template-columns: repeat(9, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-10 .kg-settings-table__grid { grid-template-columns: repeat(10, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-11 .kg-settings-table__grid { grid-template-columns: repeat(11, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-12 .kg-settings-table__grid { grid-template-columns: repeat(12, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-13 .kg-settings-table__grid { grid-template-columns: repeat(13, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-14 .kg-settings-table__grid { grid-template-columns: repeat(14, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-15 .kg-settings-table__grid { grid-template-columns: repeat(15, minmax(0, 1fr)); }
html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-table--columns-16 .kg-settings-table__grid { grid-template-columns: repeat(16, minmax(0, 1fr)); }

@media (max-width: 1023px) {
  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] > .ds-panel__body {
    padding: var(--ttoria-final-shell-outer-padding);
  }
}

@media (max-width: 767px) {
  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] #inviteForm .kg-settings-users-form-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-pack-grid--appearance {
    grid-template-columns: minmax(0, 1fr);
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-inline-controls,
  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-actions {
    width: 100%;
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-inline-controls {
    margin-inline: 0;
    padding-inline: 0;
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-actions {
    flex-direction: column;
    align-items: stretch;
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] .kg-settings-root[data-kg-saas-final-ui-settings="true"] .kg-settings-appearance-actions [data-ds-component="ds/button"] {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 479px) {
  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-backdrop {
    align-items: start;
    padding: 12px;
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host {
    width: 100%;
    max-height: calc(100dvh - 24px);
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host > .ds-modal .ds-modal__footer {
    align-items: stretch;
    flex-direction: column;
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host > .ds-modal .ds-modal__footer [data-ds-component="ds/button"] {
    max-width: 100%;
    align-self: center;
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host > .ds-modal .ds-modal__footer [data-ds-component="ds/button"][data-td-final-action-size="main"] {
    width: min(var(--ttoria-final-main-action-width), 100%);
  }

  html[data-kg-ui-standard="ttoria-saas-final-ui-v1"] body:has(.kg-settings-root[data-kg-saas-final-ui-settings="true"]) .kg-settings-modal-frame-host > .ds-modal .ds-modal__footer [data-ds-component="ds/button"][data-td-final-action-size="secondary"] {
    width: min(var(--ttoria-final-secondary-action-width), 100%);
  }
}
`;
